/* eslint-disable array-callback-return */
import CloseIcon from '@mui/icons-material/Close';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import _ from 'lodash';
import * as React from 'react';
import { ResourceContextProvider, useGetOne, useListContext, useNotify, useTranslate } from 'react-admin';
import AutomationSettingIcon from '../../assets/setting-grey-icon.svg';
import { convertNumber } from '../../components/fields';
import BonusCalculatorDetailPage from '../../dashboard/BonusCalculatorDetailPage';
import Empty from '../../layout/Empty';
import { List } from '../../layout/List';
import UserAvtarAndName from '../../layout/UserAvtarAndName';
import { POST } from '../../services/HttpService';
import { FORECAST_TAB_ICON, OVERVIEW_TAB_ICON } from '../../utils/Constants/ClassName';
import { milestoneStatusClass } from '../../utils/Constants/ConstantData';
import { NUMBER } from '../../utils/Constants/MagicNumber';
import { LabelWithTooltip } from './PropayActualAndTotalData';

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    });


const PropayDetailOverview = (props: any) => {
    const { record,maxHours, identity, workerPreview,selectedWorkerToPreview} =props;
    const [value, setValue] = React.useState(identity?.user_type === 'worker' || workerPreview.show ? 'Personal' : 'Team' );
    const [tab, setTab] = React.useState('Overview');
    const notify = useNotify()
    const [personalDetail, setPersonalDetail] = React.useState({reserve_amount:NUMBER.ZERO, performance_bonus:NUMBER.ZERO, attendance_earning:NUMBER.ZERO, hours:NUMBER.ZERO});
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
    };

    const [openModalBudget, setOpenModalBudget] = React.useState(false);
    const [openModalActual, setOpenModalActual] = React.useState(false);
    const [openModalVariance, setOpenModalVariance] = React.useState(false);
    const [openModalBonus, setOpenModalBonus] = React.useState(false);
    const [openPositiveBalance, setOpenPositiveBalance] = React.useState(false);
    const [openNegativeBalance, setOpenNegativeBalance] = React.useState(false);

    const handleCloseBudget = () => {
        setOpenModalBudget(false);
    };
    const handleCloseActual = () => {
        setOpenModalActual(false);
    };
    const handleCloseVariance = () => {
        setOpenModalVariance(false);
    };
    const handleCloseBonus = () => {
        setOpenModalBonus(false);
    };
    const handleClosePositiveBalance = () => {
        setOpenPositiveBalance(false);
    };
    const handleCloseNegativeBalance = () => {
        setOpenNegativeBalance(false);
    };
    const calculateBasepay = () => {
        let bonusOnlyHours = NUMBER.ZERO;
        record?.milestone_employee_wage_ids?.map((workerData) => {
            if(!workerData.is_remove_bonus)
            {
             bonusOnlyHours = bonusOnlyHours + workerData.hours;
            }
        });
        return bonusOnlyHours;
    }

    React.useEffect(() => {
        if (value === 'Personal') {
          const fetchPersonalDetails = async () => {
            try {
              const res:any = await POST('/api/milestone/details', {
                propay_id: record?.id,
                employee_id: workerPreview.show ? workerPreview.employee_id : identity?.employee_id,
              });
              if (res?.status === 'success') {
                setPersonalDetail(res?.details ? res?.details : {});
              }
            } catch (error) {
              notify('Error while fetching personal details. please check after sometime.');
            }
          };

          fetchPersonalDetails();
        }
      }, [identity?.employee_id, notify, record?.id, value,workerPreview?.employee_id]);

    const actualHoursForcalculation = calculateBasepay();
    const budget = record?.budget;
    const budgetHours = Number((maxHours*NUMBER.ONE).toFixed(NUMBER.TWO));
    const actualHours = Number((record?.hours*NUMBER.ONE).toFixed(NUMBER.TWO));
    const varianceAmount = ((record?.remaining_amount)*NUMBER.ONE).toFixed(NUMBER.TWO);
    const varianceHours = ((record?.remaining_hours)*NUMBER.ONE).toFixed(NUMBER.TWO);
    const actualAmount = record?.attendance_earning + Number(record.ot_amt);
    const approvedBonus = record?.performance_bonus;
    const positiveBalance = record?.reserve_amount;
    const negativeBalance = record?.deficit_amount;
    const actualPercentComplete = `${(NUMBER.HUNDRED * (actualAmount / budget )) > NUMBER.ZERO ? (NUMBER.HUNDRED * (actualAmount / budget)).toFixed(NUMBER.TWO) : NUMBER.ZERO}%`
    const PercenatgeChange = (record?.performance_bonus/actualAmount)* NUMBER.HUNDRED;
    const PerhourChange = actualHoursForcalculation ? record.performance_bonus/actualHoursForcalculation : NUMBER.ZERO;
    const translate = useTranslate();
    const personalBalance = Number((personalDetail?.reserve_amount*NUMBER.ONE).toFixed(NUMBER.TWO));
    const personalBonus = Number((personalDetail?.performance_bonus*NUMBER.ONE).toFixed(NUMBER.TWO));
    const personalActualBalance = Number((personalDetail?.attendance_earning*NUMBER.ONE).toFixed(NUMBER.TWO));
    const personalActualHours = Number((personalDetail?.hours*NUMBER.ONE).toFixed(NUMBER.TWO));
    const personalPercenatgeChange = Number(((personalDetail?.performance_bonus/personalDetail?.attendance_earning)* NUMBER.HUNDRED).toFixed(NUMBER.TWO));
    const personalPerhourChange = personalDetail?.hours ? Number((personalDetail?.performance_bonus/personalDetail?.hours).toFixed(NUMBER.TWO)) : NUMBER.ZERO;
    const workerPoolPercent = (record?.worker_bonus_percent*NUMBER.ONE).toFixed(NUMBER.TWO);
    const companyPoolPercent = (record?.company_bonus_percent*NUMBER.ONE).toFixed(NUMBER.TWO);
    // const companyPool = ((Number(varianceAmount)*Number(companyPoolPercent))/100).toFixed(2);
    // const workerPool = ((Number(varianceAmount)*Number(workerPoolPercent))/100).toFixed(2);

    return (
        <>
            {/* <PropayGroupDetail /> */}
            <Box sx={{ width: '100%', typography: 'body1' }} className='overview-new-tabs'>
                <TabContext value={tab}>
                <TabList aria-label="Overview Forecast tabs example" onChange={handleChangeTab} className='overview-tabs-row'>
                <Tab icon={OVERVIEW_TAB_ICON()} label="Overview" value="Overview" />
                    {record?.employee_wage_ids?.length && ['pending', 'started', 'completed']?.includes(record?.status) && <Tab icon={FORECAST_TAB_ICON()} label="Forecast" value="Forecast"  />}
                    {/* <Tab icon={BONUS_POOL_TAB_ICON()} label="Bonus Pool" value="Bonus Pool"  /> */}
                </TabList>
                <TabPanel value="Overview">
                <TabContext value={value}>
                    <div className='overview-budget-box'>
                    <Box className='overview-new-tabs-row'>
                        {(identity?.user_type === 'worker' || workerPreview.show)  && <TabList onChange={handleChange} aria-label="Personal Team tabs example" className='team-personal-tabs'>
                            <Tab label="Personal" value="Personal" />
                            <Tab label="Team" value="Team" />
                        </TabList>}
                    </Box>
                    <TabPanel value="Personal">
                        <div className="budget-detail-sec budget-new-overview remove-hyper-linking">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Hours</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='budget-headers'>Actuals</td>
                                        <td data-title="Hours">{convertNumber((personalActualHours), identity)}</td>
                                        <td data-title="Amount">{formatter.format(personalActualBalance ? personalActualBalance : 0)}</td>
                                    </tr>
                                    <tr>
                                        <td className='budget-headers'>Approved Bonuses
                                        {record?.bonus_split_type && <Tooltip arrow placement="top" title={translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.info`!)}>
                                            <IconButton>
                                            Split: {translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.label`!)}
                                            </IconButton>
                                        </Tooltip>}
                                        </td>
                                        <td className='hidden-td-mobile'>&nbsp;</td>
                                        <td data-title="Amount" className={`${Number(approvedBonus) < 0 ? 'red-text font-weight-700':''} ${Number(approvedBonus) > NUMBER.ZERO ? 'green-text font-weight-700':''}`}>
                                        <div className='approve-bonus-mobile'>
                                            {formatter.format(Number(personalBonus))}
                                        <span className='approve-bonus-value'>
                                            {record.bonus_split_type === 'by_hours' && <span className='text-green font-weight-700'>
                                            ({personalDetail.performance_bonus ? formatter.format(personalPerhourChange): formatter.format(NUMBER.ZERO)}/hr)</span>}
                                        {record.bonus_split_type === 'by_wage' && <span className='approve-bonus-text'>
                                            ({personalDetail.performance_bonus ? parseFloat(personalPercenatgeChange.toString()).toFixed(NUMBER.TWO): '0'}%)
                                            {personalDetail.performance_bonus ? <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                                            <path d="M1 6.5L6 1.5M6 1.5L11 6.5M6 1.5V13.5" stroke="#4FCA4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg> : ''}
                                            </span>}
                                        </span>
                                        </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='budget-headers'>Balance</td>
                                        <td className='hidden-td-mobile'>&nbsp;</td>
                                        <td data-title="Amount">{formatter.format(personalBalance)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </TabPanel>
                    <TabPanel value="Team">
                    <div className="budget-detail-sec budget-new-overview">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Hours</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='budget-headers'>
                                        <p className='budget-modal-text' onClick={()=> setOpenModalBudget(true)}>Budget</p>
                                        {record?.budget_option === 'amount' ? <LabelWithTooltip
                                            tooltipTitle='Completion is tracked against amount instead of hours. Hours will fluctuate based on the worker hours and their wage.'
                                             label='Fixed Amount'/> :
                                            <LabelWithTooltip
                                            tooltipTitle='Completion is tracked against hours instead of amount. Amount will fluctuate based on the worker hours and their wage.'
                                             label='Fixed Hours'/>}
                                        </td>
                                        <td data-title="Hours">{convertNumber((budgetHours), identity)}</td>
                                        <td data-title="Amount">{formatter.format(budget)}</td>
                                    </tr>
                                    <tr>
                                        <td className='budget-headers' onClick={()=> setOpenModalActual(true)}>Actuals</td>
                                        <td data-title="Hours"><div className='actual-hour-value'>{convertNumber((actualHours),identity)}{record?.budget_option === 'hours' && <span className='hrs-overview-text' >({isFinite(parseFloat(actualPercentComplete)) ? actualPercentComplete : '0%'} spent)</span>}</div></td>
                                        <td data-title="Amount"><div className='actual-hour-value'>{formatter.format(actualAmount ? actualAmount : 0)}{record?.budget_option === 'amount' && <span className='hrs-overview-text' >({isFinite(parseFloat(actualPercentComplete)) ? actualPercentComplete : '0%'} spent)</span>}</div></td>
                                    </tr>
                                    <tr>
                                        <td className='budget-headers' onClick={()=> setOpenModalVariance(true)}>Variance</td>
                                        <CommonTdValue value={Number(varianceHours)} identity={identity}/>
                                        <CommonTdAmount amount={Number(varianceAmount)}/>
                                    </tr>
                                    {record?.is_bonus_pool_enabled && <><tr className='company-worker-pool-tr'>
                                                <td colSpan={2} className='hidden-td-mobile'>{identity?.company?.company_pool_label ? identity?.company?.company_pool_label : 'Company Pool'}</td>
                                                <td data-title={identity?.company?.company_pool_label ? identity?.company?.company_pool_label : 'Company Pool'}>{formatter.format(Number(record?.company_pool))} ({companyPoolPercent}%)</td>
                                        </tr>
                                        <tr className='company-worker-pool-tr'>
                                            <td colSpan={2} className='hidden-td-mobile'>{identity?.company?.worker_pool_label ? identity?.company?.worker_pool_label : 'Worker Pool'}</td>
                                            <td data-title={identity?.company?.worker_pool_label ? identity?.company?.worker_pool_label : 'Worker Pool'}>{formatter.format(Number(record?.worker_pool))} ({workerPoolPercent}%)</td>
                                        </tr>
                                        </>
                                        }
                                    <tr>
                                        <td className='budget-headers' onClick={()=> setOpenModalBonus(true)}>Approved Bonuses
                                        {record?.bonus_split_type && <Tooltip arrow placement="top" title={translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.info`!)}>
                                            <IconButton>
                                            Split: {translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.label`!)}
                                            </IconButton>
                                        </Tooltip>}
                                        </td>
                                        <td className='hidden-td-mobile'>&nbsp;</td>
                                        <td data-title="Amount" className={`${Number(approvedBonus) < 0 ? 'red-text font-weight-700':''} ${Number(approvedBonus) > NUMBER.ZERO ? 'green-text font-weight-700':''}`}>
                                        <div className='approve-bonus-mobile'>
                                            {formatter.format(Number(approvedBonus))}
                                        <span className='approve-bonus-value'>
                                            {record.bonus_split_type === 'by_hours' && <span className='text-green font-weight-700'>
                                            ({record.performance_bonus ? formatter.format(PerhourChange): formatter.format(NUMBER.ZERO)}/hr)</span>}
                                        {record.bonus_split_type === 'by_wage' && <span className='approve-bonus-text'>
                                            ({record.performance_bonus ? parseFloat(PercenatgeChange.toString()).toFixed(NUMBER.TWO): '0'}%)
                                            {record.performance_bonus ? <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                                            <path d="M1 6.5L6 1.5M6 1.5L11 6.5M6 1.5V13.5" stroke="#4FCA4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg> : ''}
                                            </span>}
                                        </span>
                                        </div>
                                        </td>
                                    </tr>

                                    <tr className='positive-balance'>
                                        <td className='budget-headers' onClick={()=> setOpenPositiveBalance(true)}>Positive Balance</td>
                                        <td className='hidden-td-mobile'>&nbsp;</td>
                                        <td data-title="Amount">{formatter.format(positiveBalance)} </td>
                                    </tr>

                                    {record.status !== 'paid' ? <tr className='negative-balance'>
                                        <td className='budget-headers' onClick={()=> setOpenNegativeBalance(true)}>Negative Balance</td>
                                        <td className='hidden-td-mobile'>&nbsp;</td>
                                        <td data-title="Amount">({formatter.format(negativeBalance ? negativeBalance : 0)})</td>
                                    </tr>:(record.overage) ? <tr>
                                         <td colSpan={2} className='budget-headers hidden-td-mobile' onClick={()=> setOpenNegativeBalance(true)}>Overage</td>
                                         <td data-title='Overage'>{formatter.format(record.overage)}</td>
                                        </tr>:''}
                                </tbody>
                            </table>
                        </div>
                    </TabPanel>
                    </div>
                </TabContext>
                </TabPanel>
                <TabPanel value="Forecast">
                <BonusCalculatorDetailPage record={record} maxHours={maxHours} workerPreview={workerPreview}/>
                </TabPanel>
                </TabContext>
            </Box>
            <HandleModalOpen identity={identity} record={record} openModalActual={openModalActual} openModalBonus={openModalBonus} openModalBudget={openModalBudget} openModalVariance={openModalVariance}
            handleCloseActual={handleCloseActual} handleCloseBonus={handleCloseBonus} handleCloseBudget={handleCloseBudget} handleCloseVariance={handleCloseVariance}
            openPositiveBalance={openPositiveBalance} openNegativeBalance={openNegativeBalance}
            handleClosePositiveBalance={handleClosePositiveBalance} handleCloseNegativeBalance={handleCloseNegativeBalance}
            />
        </>
    )
}
export default PropayDetailOverview;

const CommonTdValue = ({value, identity}) => {
    return(
        <td data-title="Hours" className={`${value < 0 ? 'red-text font-weight-700':''} ${value > NUMBER.ZERO ? 'green-text font-weight-700':''}`}>{convertNumber((value), identity)}</td>
    )
}
const CommonTdAmount = ({amount}) => {
    return(
        <td data-title="Amount" className={`${amount < 0 ? 'red-text font-weight-700':''} ${amount > NUMBER.ZERO ? 'green-text font-weight-700':''}`}>{formatter.format(amount)}</td>
    )
}

const HandleModalOpen = ({identity,openModalBudget,openModalActual, openModalVariance, openModalBonus, record,
     handleCloseBudget, handleCloseActual, handleCloseVariance, handleCloseBonus,handleCloseNegativeBalance,
     openPositiveBalance,openNegativeBalance,handleClosePositiveBalance}) => {

    const positiveBalanceReocrd = record?.milestone_employee_wage_ids?.filter((item)=> item.remaining_reserve_amount > NUMBER.ZERO);
    const negativeBalanceReocrd = record?.milestone_employee_wage_ids?.filter((item)=> item.remaining_deficit_amount > NUMBER.ZERO);

    return (
        <>
        <ResourceContextProvider value='propays'>
        <>
        {openModalActual &&
        <List
            empty={false}
            filter={{'parent_id': {_eq: record.id}}}
            titleActionProps={{ showCreate: false }}
            actions={false}
            className='milestone-RaList-root'
            title=' '
            pagination={false}
            perPage={500}
            hasCreate={false}
            emptyWhileLoading
        >
        <ActualDialog openModal={openModalActual} handleClose={handleCloseActual} identity={identity}/>
        </List>
        }
        {openModalVariance &&
        <List
            empty={false}
            filter={{'parent_id': {_eq: record.id}}}
            titleActionProps={{ showCreate: false }}
            actions={false}
            className='milestone-RaList-root'
            title=' '
            pagination={false}
            perPage={500}
            hasCreate={false}
            emptyWhileLoading
        >
        <VarianceDialog openModal={openModalVariance} handleClose={handleCloseVariance} identity={identity}/>
        </List>
        }
        {openModalBonus &&
        <List
            empty={false}
            filter={{'parent_id': {_eq: record.id}, performance_bonus:{_gt:0}}}
            titleActionProps={{ showCreate: false }}
            actions={false}
            className='milestone-RaList-root'
            title=' '
            pagination={false}
            perPage={500}
            hasCreate={false}
            emptyWhileLoading
        >
        <ApprovedBonusDialog openModal={openModalBonus} handleClose={handleCloseBonus}/>
        </List>
        }
        {openModalBudget &&
        <List
            empty={false}
            filter={{'parent_id': {_eq: record.id}}}
            titleActionProps={{ showCreate: false }}
            actions={false}
            className='milestone-RaList-root'
            title=' '
            pagination={false}
            perPage={500}
            hasCreate={false}
            emptyWhileLoading
        >
        <BudgetDialog openModal={openModalBudget} handleClose={handleCloseBudget} identity={identity}/>
        </List>
        }
        </>
        </ResourceContextProvider>
        <PositiveBalanceDialog openModal={openPositiveBalance} handleClose={handleClosePositiveBalance} records={positiveBalanceReocrd}/>
        <NegativeBalanceDialog openModal={openNegativeBalance} handleClose={handleCloseNegativeBalance} records={negativeBalanceReocrd} isOverage={record?.status === 'paid' && record?.overage}/>
        </>
    )
}

const BudgetDialog = ({openModal, handleClose, identity}) => {
    const { data, total } = useListContext();
    const calculateTotalBudgetAmount = () => {
        let total = NUMBER.ZERO;
        data.forEach((row) => {
          total += row.budget;
        });
        return total;
      };
      const calculateTotalBudgetHours = () => {
        let total = NUMBER.ZERO;
        data.forEach((row) => {
          total += row.budget_hours;
        });
        return total;
      };

    return(
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="popup-user-dialog-title"
            aria-describedby="popup-user-dialog-description"
            className="budget-detail-modal"
        >
            <DialogTitle className="user-working-title">
            Budget Details
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: NUMBER.EIGHT,
                        top: NUMBER.EIGHT,
                        color: theme =>
                            theme.palette.grey[NUMBER.FIVE_HUNDRED],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                    <DialogContentText className="user-working-description">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Milestone</TableCell>
                                    <TableCell>Hrs.</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            {total > NUMBER.ZERO ? <TableBody>
                                {total > NUMBER.ZERO && data.map((item) => {
                                        return(
                                    <TableRow key={item.id+'asd'}>
                                    <TableCell><Typography variant="body1" gutterBottom>{item.display_name}</Typography>
                                    <Typography
                                        className={milestoneStatusClass(
                                            item.status
                                        )}
                                    >
                                        {' '}
                                        {item.status === 'paid'
                                            ? 'Closed'
                                            :  item.status}
                                    </Typography>
                                    </TableCell>
                                    <TableCell>{
                                    item?.budget_option === 'hours'
                                    ? convertNumber(_.round((item.budget_hours), NUMBER.TWO), identity)
                                    : convertNumber(_.round((item?.estimated_hours), NUMBER.TWO), identity)
                                    }</TableCell>
                                    <TableCell>{formatter.format(item.budget)}</TableCell>
                                </TableRow>
                                )})}
                                    <TableRow className='table-footer'>
                                    <TableCell>Total</TableCell>
                                    <TableCell>{convertNumber((calculateTotalBudgetHours()*1).toFixed(2), identity)}</TableCell>
                                    <TableCell>{formatter.format(calculateTotalBudgetAmount())}</TableCell>
                                    </TableRow>

                            </TableBody>:
                        <TableBody><TableCell colSpan={3}><Empty/></TableCell></TableBody>
                        }
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

const ActualDialog = ({openModal, handleClose, identity}) => {
    const { data, total } = useListContext();
    const calculateTotalActualAmount = () => {
        let total = NUMBER.ZERO
        data.forEach((row) => {
          total += row.attendance_earning;
        });
        return total;
      };
      const calculateTotalActualHours = () => {
        let total = NUMBER.ZERO
        data.forEach((row) => {
          total += row.hours;
        });
        return total;
      };

    return(
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="popup-user-dialog-title"
            aria-describedby="popup-user-dialog-description"
            className="budget-detail-modal"
        >
            <DialogTitle className="user-working-title">
            Actual Details
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: NUMBER.EIGHT,
                        top: NUMBER.EIGHT,
                        color: theme =>
                            theme.palette.grey[NUMBER.FIVE_HUNDRED],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                    <DialogContentText className="user-working-description">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Milestone</TableCell>
                                    <TableCell>Hrs.</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            {total > NUMBER.ZERO ? <TableBody>
                                {total > NUMBER.ZERO && data.map((item) => {
                                        return(
                                    <TableRow key={item.id+'asd'}>
                                    <TableCell><Typography variant="body1" gutterBottom>{item.display_name}</Typography>
                                    <Typography
                                        className={milestoneStatusClass(
                                            item.status
                                        )}
                                    >
                                        {' '}
                                        {item.status === 'paid'
                                            ? 'Closed'
                                            :  item.status}
                                    </Typography>
                                    </TableCell>
                                    <TableCell>{convertNumber((item.hours*1).toFixed(NUMBER.TWO), identity)}</TableCell>
                                    <TableCell>{formatter.format(item.attendance_earning)}</TableCell>
                                </TableRow>
                                )})}
                                    <TableRow className='table-footer'>
                                    <TableCell>Total</TableCell>
                                    <TableCell>{convertNumber((calculateTotalActualHours()*1).toFixed(NUMBER.TWO), identity)}</TableCell>
                                    <TableCell>{formatter.format(calculateTotalActualAmount())}</TableCell>
                                    </TableRow>
                            </TableBody> :
                            <TableBody><TableCell colSpan={3}><Empty/></TableCell></TableBody>
                            }
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

const VarianceDialog = ({openModal, handleClose, identity}) => {
    const { data, total } = useListContext();
    const calculateTotalVarianceAmount = () => {
        let total = NUMBER.ZERO
        data.forEach((row) => {
          const varianceAmount = ((row?.remaining_amount)*1).toFixed(2);
          total +=  Number(varianceAmount);
        });
        return total;
      };
      const calculateTotalVarianceHours = () => {
        let total = NUMBER.ZERO
        data.forEach((row) => {
          const varianceHoursDiv = row?.remaining_hours;
          const varianceHours = ((varianceHoursDiv)*1).toFixed(2);
          total += Number(varianceHours);
        });
        return total;
      };

      return(
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="popup-user-dialog-title"
            aria-describedby="popup-user-dialog-description"
            className="budget-detail-modal"
        >
            <DialogTitle className="user-working-title">
            Variance Details
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: NUMBER.EIGHT,
                        top: NUMBER.EIGHT,
                        color: theme =>
                            theme.palette.grey[NUMBER.FIVE_HUNDRED],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                    <DialogContentText className="user-working-description">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Milestone</TableCell>
                                    <TableCell>Hrs.</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            {total > NUMBER.ZERO ? <TableBody>
                                {total > NUMBER.ZERO && data.map((item) => {
                                        const varianceAmount = ((item?.remaining_amount)*1).toFixed(2);
                                        const varianceHoursDiv = item?.remaining_hours;
                                        const varianceHours = Number((varianceHoursDiv*1).toFixed(2));
                                        return(
                                    <TableRow key={item.id+'asd'}>
                                    <TableCell><Typography variant="body1" gutterBottom>{item.display_name}</Typography>
                                    <Typography
                                        className={milestoneStatusClass(
                                            item.status
                                        )}
                                    >
                                        {' '}
                                        {item.status === 'paid'
                                            ? 'Closed'
                                            :  item.status}
                                    </Typography>
                                    </TableCell>
                                    <TableCell className={`${Number(varianceHours) > NUMBER.ZERO ? 'green-text font-weight-700':''} ${Number(varianceHours) < NUMBER.ZERO ? 'red-text font-weight-700':''}`}>{convertNumber((varianceHours), identity)}</TableCell>
                                    <TableCell className={`${Number(varianceAmount) > NUMBER.ZERO ? 'green-text font-weight-700':''} ${Number(varianceAmount) < NUMBER.ZERO ? 'red-text font-weight-700':''}`}>{formatter.format(Number(varianceAmount))}</TableCell>
                                </TableRow>
                                )})}
                                    <TableRow className='table-footer'>
                                    <TableCell>Total</TableCell>
                                    <TableCell className={`${calculateTotalVarianceHours() > NUMBER.ZERO ? 'green-text font-weight-700':''} ${calculateTotalVarianceHours() < NUMBER.ZERO ? 'red-text font-weight-700':''}`}>{convertNumber((calculateTotalVarianceHours()*1).toFixed(2), identity)}</TableCell>
                                    <TableCell className={`${calculateTotalVarianceAmount() > NUMBER.ZERO ? 'green-text font-weight-700':''} ${calculateTotalVarianceAmount() < NUMBER.ZERO ? 'red-text font-weight-700':''}`}>{formatter.format(calculateTotalVarianceAmount())}</TableCell>
                                    </TableRow>

                            </TableBody> :
                            <TableBody><TableCell colSpan={3}><Empty/></TableCell></TableBody>
                            }

                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

const ApprovedBonusDialog = ({openModal, handleClose}) => {
    const { data, total } = useListContext();
    const calculateTotalApprovedBonus = () => {
        let total = NUMBER.ZERO;
        data.forEach((row) => {
          total += row.performance_bonus;
        });
        return total;
      };

    return(
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="popup-user-dialog-title"
            aria-describedby="popup-user-dialog-description"
            className="budget-detail-modal"
        >
            <DialogTitle className="user-working-title">
            Approved Bonuses Details
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: NUMBER.EIGHT,
                        top: NUMBER.EIGHT,
                        color: theme =>
                            theme.palette.grey[NUMBER.FIVE_HUNDRED],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                    <DialogContentText className="user-working-description">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Milestone</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            {total > NUMBER.ZERO ? <TableBody>
                                {total > NUMBER.ZERO && data.map((item) => {
                                        return(
                                    <TableRow key={item.id+'asd'}>
                                    <TableCell><Typography variant="body1" gutterBottom>{item.display_name}</Typography>
                                    <Typography
                                        className={milestoneStatusClass(
                                            item.status
                                        )}
                                    >
                                        {' '}
                                        {item.status === 'paid'
                                            ? 'Closed'
                                            :  item.status}
                                    </Typography>
                                    </TableCell>
                                    <TableCell>{formatter.format(item.performance_bonus)}</TableCell>
                                </TableRow>
                                )})}
                                    <TableRow className='table-footer'>
                                    <TableCell>Total</TableCell>
                                    <TableCell>{formatter.format(calculateTotalApprovedBonus())}</TableCell>
                                    </TableRow>

                            </TableBody> :
                            <TableBody><TableCell colSpan={2}><Empty/></TableCell></TableBody>
                            }

                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

const PositiveBalanceDialog = ({openModal, handleClose, records}) => {
      const calculateTotalBudgetHours = () => {
        let total = NUMBER.ZERO;
        records.forEach((row) => {
          total += row.remaining_reserve_amount;
        });
        return total;
      };

      return(
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="popup-user-dialog-title"
            aria-describedby="popup-user-dialog-description"
            className="budget-detail-modal"
        >
            <DialogTitle className="user-working-title">
            Positive Balance Details
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: NUMBER.EIGHT,
                        top: NUMBER.EIGHT,
                        color: theme =>
                            theme.palette.grey[NUMBER.FIVE_HUNDRED],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                    <DialogContentText className="user-working-description">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Worker</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            {records?.length > NUMBER.ZERO ?  <TableBody>
                                {records?.length > NUMBER.ZERO && records.map((item) => {
                                        return(
                                    <TableRow key={item.id+'asd'}>
                                    <TableCell>
                                        <div className='budget-modal-Avatar'>
                                        <EmployeeDetails id={item?.employee_id} removeBonus={item?.is_remove_bonus}/>
                                        </div>
                                    </TableCell>
                                    <TableCell>{formatter.format(item.remaining_reserve_amount)}</TableCell>
                                </TableRow>
                                )})}
                                    <TableRow className='table-footer'>
                                    <TableCell>Total</TableCell>
                                    <TableCell>{formatter.format(calculateTotalBudgetHours())}</TableCell>
                                    </TableRow>

                            </TableBody> :
                            <TableBody><TableCell colSpan={2}><Empty/></TableCell></TableBody>
                            }
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

const NegativeBalanceDialog = ({openModal, handleClose, records,isOverage}) => {
      const calculateTotalBudgetHours = () => {
        let total = NUMBER.ZERO;
        records.forEach((row) => {
          total += row.remaining_deficit_amount;
        });
        return total;
      };

    return(
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="popup-user-dialog-title"
            aria-describedby="popup-user-dialog-description"
            className="budget-detail-modal"
        >
            <DialogTitle className="user-working-title">
           {isOverage ? 'Overage':'Negative Balance'} Details
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: NUMBER.EIGHT,
                        top: NUMBER.EIGHT,
                        color: theme =>
                            theme.palette.grey[NUMBER.FIVE_HUNDRED],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                    <DialogContentText className="user-working-description">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Worker</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            {records?.length > NUMBER.ZERO ? <TableBody>
                                {records?.length > NUMBER.ZERO && records.map((item) => {
                                        return(
                                    <TableRow key={item.id+'asd'}>
                                    <TableCell>
                                        <div className='budget-modal-Avatar'>
                                        <EmployeeDetails id={item?.employee_id} removeBonus={item?.is_remove_bonus}/>
                                        </div>
                                    </TableCell>
                                    <TableCell className='red-text'>({formatter.format(item.remaining_deficit_amount)})</TableCell>
                                </TableRow>
                                )})}
                                    <TableRow className='table-footer'>
                                    <TableCell>Total</TableCell>
                                    <TableCell className='red-text'>({formatter.format(calculateTotalBudgetHours())})</TableCell>
                                    </TableRow>

                            </TableBody> :
                            <TableBody><TableCell colSpan={2}><Empty/></TableCell></TableBody>
                            }
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

const EmployeeDetails = (props: { id: any, removeBonus:boolean })=> {
    const { id, removeBonus } = props;
    const { data } = useGetOne(
      'employees',
      { id }
    );
    return(
        <>
         {data && <UserAvtarAndName record={data} is_remove_bonus={removeBonus}/>}
         </>
    );
  };

  const PropayGroupDetail = () => {
    return (
      <>
        <Grid container spacing={1.5} className='propay-group-row'>
            <Grid item xs={6} sm={3} md={2}>
                <div className='detail-group-box'>
                    <h3>$2,729.25</h3>
                    <p>Overage</p>
                </div>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
                <div className='detail-group-box'>
                    <h3>$1,800.00</h3>
                    <p>Total Budget</p>
                </div>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
                <div className='detail-group-box'>
                    <h3>319:30</h3>
                    <p>Total Hours Worked</p>
                </div>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
                <div className='detail-group-box'>
                    <h3>$31,250.00</h3>
                    <p>Total Actuals</p>
                </div>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
                <div className='detail-group-box group-pass'>
                    <h3>$2,250.00</h3>
                    <p>Total Variance</p>
                </div>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
                <div className='detail-group-box'>
                    <h3>$1,835.38</h3>
                    <p>Total Appvd Bonuses</p>
                </div>
            </Grid>
        </Grid>
        <div className='detail-automation'>
        <div className='automation-head'>
        <Typography variant="h4">Automation</Typography>
        <Button className='create-automation-btn'>Add Automation</Button>
        </div>
        <div className='automation-blank'>
        <img src={AutomationSettingIcon} alt='Add Automation' />
        <h5>Your automations will be here</h5>
        </div>
      </div>

      </>
    );
  };
